import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip, Typography } from 'antd';
import Subtitle from '../../../../shared/ui/Subtitle';
import BaseCheckbox from '../../../../shared/ui/BaseCheckbox';
import { actionCreators, selectors, sliceKeys } from '../../../../model';
import styles from './index.module.scss';

const { selectHasSearchOrFilter } = selectors[sliceKeys.rooms];

const {
  createRoomsCountSelector,
  createExcludedCountSelector,
  createHouseExcludedRoomIdsSelector,
} = selectors[sliceKeys.houses];

const { allRoomsExcludeClicked } = actionCreators[sliceKeys.houses];

const RoomsHeader = ({ item }) => {
  const { name, rooms } = item;

  const houseId = rooms[0].houseId;

  const hasSearchOrFilter = useSelector(selectHasSearchOrFilter);

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <Subtitle stickyToTop={false} className={styles.title}>
          {name}
        </Subtitle>
        {hasSearchOrFilter && <CheckboxBlock rooms={rooms} />}
      </div>
      <ExcludedRoomsCount houseId={houseId} />
    </div>
  );
};

export default RoomsHeader;

function ExcludedRoomsCount({ houseId }) {
  const selectors = useMemo(
    () => ({
      roomsCount: createRoomsCountSelector(houseId),
      excludedCount: createExcludedCountSelector(houseId),
    }),
    [houseId]
  );
  const roomsCount = useSelector(selectors.roomsCount);
  const excludedCount = useSelector(selectors.excludedCount);

  return (
    <Typography.Text type="secondary">
      Исключено: {excludedCount} из {roomsCount}
    </Typography.Text>
  );
}

function CheckboxBlock({ rooms: currentRooms }) {
  const dispatch = useDispatch();

  const houseId = currentRooms[0]?.houseId;

  const selectExcludedRoomIds = useMemo(
    () => createHouseExcludedRoomIdsSelector(houseId),
    [houseId]
  );

  const excludedRoomIds = useSelector(selectExcludedRoomIds);

  const { state, includedRooms } = useMemo(() => {
    let excludedCount = 0;
    const includedRooms = [];

    currentRooms.forEach((room) => {
      if (excludedRoomIds?.has(room.id)) {
        excludedCount++;
      } else {
        includedRooms.push(room);
      }
    });

    return {
      state:
        excludedCount === 0
          ? 'checked'
          : excludedCount === currentRooms.length
          ? 'unchecked'
          : 'indeterminate',
      includedRooms,
    };
  }, [currentRooms, excludedRoomIds]);

  const checked = state === 'checked';

  const handleChange = () => {
    const nextChecked = !checked;

    dispatch(
      allRoomsExcludeClicked(
        nextChecked ? currentRooms : includedRooms,
        nextChecked
      )
    );
  };

  return (
    <Tooltip title={checked ? 'Исключить помещения' : 'Включить помещения'}>
      <BaseCheckbox
        checked={checked}
        indeterminate={state === 'indeterminate'}
        onChange={handleChange}
      />
    </Tooltip>
  );
}
